//Projects Domains
export const METRICS_DOMAIN = "http://metricas.caribemedia.com.do";
export const AMCHAM_DOMAIN = "amchamonline.com.do";
export const YP_DOMAIN = "paginasamarillas.com.do";
export const SLOL_DOMAIN = "saludonline.com.do";
export const SPPR_DOMAIN = "superpagespr.com";
export const PTG_DOMAIN = "placestogodr.com";

//Book Codes
export const AMCHAM_BOOKCODE = "AMOL";
export const SPPR_BOOKCODE = "SPPR";
export const SLOL_BOOKCODE = "SLOL";
export const YP_BOOKCODE = "SPPG";
export const PTG_BOOKCODE = "PTG";
export const BR_BOOKCODE = "BR";

//Google
export const GA_VERSIONS = { UA: "UA", GA4: "GA4" };

//Country ID
export const BUSINESS_UNIT_ID = {
  RD: 1,
  PR: 2,
  IP: 3
};

export const COUNTRY_ID = {
  1: "RD",
  2: "PR",
  3: "IP"
};

export const APP_NAME_CONFIG = {
  INFOPAGINAS: "infopaginas",
  CARIBEMEDIA: "caribemedia",
  AXESA: "axesa"
};

//AZURE
export const HOST_AZURE_STORAGE = "stdashboardcm.blob.core.windows.net";

//CLASS CODE
export const CLASS_CODE = {
  SPOTIFY: "SPY",
  LINKEDIN: "LKN",
  GOOGLE_MY_BUSINESS: "GMB",
  INFOPAGINAS: "IPPR",
  TIKTOK:"TKTK"
};

export const ADS_DEFINITIONS = {
  CTR:
    "El porcentaje de anuncios dentro del conjunto de anuncios publicados en los que se hizo clic.",
  CPC: "El coste por click del anuncio",
  IMPRESSIONS:
    "Cantidad de veces que su publicidad fue expuesta a su público objetivo",
  CLICKS: "Interacciones con la audiencia",
  COMPLETES:
    "La cantidad de anuncios publicados que se reprodujeron hasta el final.",
  SKIPS: "La cantidad de saltos que el usuario ha hecho al anuncio.",
  STARTS:
    "La cantidad de veces que un usuario comienza a escuchar/ver su anuncio.",
  LIKES: "Número de likes que recibió su anuncio",
  COMMENTS: "Número de comentarios en el anuncio",
  VIDEO_VIEWS: "Cuantas visitas logró su video",
  PAGE_CLICKS: "Cuántos clicks recibe la página por los anuncios"
};
